<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Cart AgentId Mismatch</h4>
</div>
<div class="modal-body">
    <p>You are attempting to add an Agent to your existing Cart that has a different Agent. Would you like to clear your Cart?</p>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" aria-label="Close" data-bs-dismiss="modal" (click)="cancel()">No</button>
        <button class="btn--accent" type="submit" data-bs-dismiss="modal" (click)="clearCart()">Yes</button>
    </div>
</div>
